'use client'

import { useCallback, useContext, useState } from 'react'
import EshopSearch from '../Search'
import ProductList, { ProductListProps } from '../ProductList'
import { SearchProductList } from '../ProductList/SearchList'
import { EshopContext } from '../EshopProvider'
import EshopCategories from '../Categories'
import { EshopDocumentsLetters } from '@/eshop/components/Documents'
import { useSearchParams } from 'next/navigation'

type Nullable<T> = {
    [K in keyof T]?: T[K] | null
}

interface Props extends Nullable<ProductListProps> {
    initialLetter: string
}

export function ProductListWrapper({
    className,
    initialData,
    initialLetter,
}: Props) {
    const searchParams = useSearchParams()
    const searchQuery = searchParams.get('search')
    const { search, setSearch } = useContext(EshopContext)
    if (searchQuery) setSearch(searchQuery)
    const [letter, setLetter] = useState(initialLetter || 'A')

    const hasInitialData = !!initialData

    const handleLetterChange = useCallback((l: string | null) => {
        !!l && setLetter(l)
    }, [])

    return (
        <>
            <EshopSearch
                initSearch={search}
                onSearch={setSearch}
                debounce={300}
            />
            {!search && (
                <>
                    <br className="h-6" />
                    <EshopDocumentsLetters
                        onChange={handleLetterChange}
                        activeLetter={letter}
                    />
                    <hr className="my-6" />
                </>
            )}
            {!search && <EshopCategories />}
            {!search && hasInitialData ? (
                <ProductList
                    initialData={initialData}
                    className={className || undefined}
                    letter={letter}
                    setLetter={setLetter}
                />
            ) : null}
            {!!search && <SearchProductList search={search} />}
        </>
    )
}
